import { ScrollablePane, ScrollbarVisibility } from '@fluentui/react'
import _ from 'lodash'
import React, { Component } from 'react'
import RbLabel from '../../../bosch-react/components/label/RbLabel'

interface IProps {
    height?:number
    children?:any
}
interface IState {

}
export default class DetailsListWrapper extends Component<IProps,IState> {
  render() {
    return (
        <div className="ms-Grid-row" style={{ height: ((_.isUndefined(this.props.height)) ? 68 : this.props.height) + "vh", overflowY: "auto", overflowX: "visible", position: "relative" }}>
        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>{this.props.children}</ScrollablePane>
    </div>
    )
  }
}
